/**
 * The Poker room's Train tab — six cards, and not one new drill.
 *
 * ============================ WHAT A TRAIN CARD IS =============================
 * The trainer already runs one real drill (preflop shove-or-fold, the only thing the
 * pipeline has solved) across a selection of game type, table size, situation and stack
 * depth. Six of those points are worth a name, so they get one. Nothing here computes,
 * grades or stores anything: a card is a link into `routes/Train.tsx` with an opening
 * selection, and Build a Drill is the same page with its full facet rail and no preset.
 *
 * `lib/drills.ts` still owns the claim about which STREETS exist — preflop is live and
 * the four postflop entries are drawn, disabled and say why. That list is inside the
 * trainer where it belongs; this tab does not repeat it, and it does not offer a card
 * for anything the library cannot deal.
 * ===============================================================================
 */
import { Link } from "react-router-dom";
import { PresetCard } from "./PresetCard";
import { TRAIN_CARDS } from "./poker-cards";
import "./rooms.css";

export function PokerTrain() {
  const cards = TRAIN_CARDS.filter((c) => !c.build);
  const build = TRAIN_CARDS.find((c) => c.build);
  return (
    <div className="tab-train">
      <div className="cardgrid">
        {cards.map((c) => (
          <PresetCard key={c.id} title={c.title} line={c.line} verifying={c.verifying}
                      action="Drill" to={`/poker/train/run?card=${c.id}`} />
        ))}
        {build && (
          <PresetCard quiet title={build.title} line={build.line} action="Open"
                      to="/poker/train/build" />
        )}
      </div>
      <p className="tab-note muted small">
        Every spot is a decision from a published solve. Where a chart does not exist the
        drill falls back to one that does, and the trainer's own setup bar says which —
        a card is a starting point, never a claim that something has been solved.{" "}
        <Link to="/fair">How the charts were made</Link>.
      </p>
    </div>
  );
}
